import {H2Neutral50, H2, PMarginSm} from '@/typography';
import Container from '@/container';
import {Col, Row, Grid} from '@/grid';
import {
  withMarginBottomXxl,
  withMarginBottomSm,
  withMarginBottomXl,
  withIsPaddedRightMd,
  withMarginRightSectionToZero
} from '@/hocs/withSpacing';
import {withBgNeutral900, withNeutral50} from '@/hocs/withColors';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import PictureWrapper from '@/ui/images-wrapper';
import {SectionPaddingBottom} from '@/section';
import {withXSmall, withBoldWeight} from '@/hocs/withFontType';

const Neutral900Section = withBgNeutral900(SectionPaddingBottom);
const LeftCenteredMargined = withMarginBottomXxl(withTextLeftToCenter(H2Neutral50));
const DivMarginedBottomSm = withMarginBottomSm('div');
const PNeutral50MarginSm = withMarginRightSectionToZero(
  withIsPaddedRightMd(withXSmall(withNeutral50(PMarginSm)))
);
const DivMarginedBottomXl = withMarginBottomXl('div');
const H2Neutral50MarginSm = withMarginBottomSm(withBoldWeight(withXSmall(withNeutral50(H2))));

const imagePath = '/static/images/security/logos/';

const Certifications = [
  {
    imageUrl: 'gdpr',
    title: 'GDPR (General Data Protection Regulation)',
    copy: 'Workable automates privacy policy distribution, data retention, and candidate data deletion requests.'
  },
  {
    imageUrl: 'eeo',
    title: 'EEO (Equal Employment Opportunity)',
    copy: 'Workable makes it easy to collect and organize the information you need to stay compliant with EEO.'
  },
  {
    imageUrl: 'ccpa',
    title: 'CCPA',
    copy: 'Workable automatically manages data handling and privacy policy access in line with CCPA requirements.'
  },
  {
    imageUrl: 'ofccp',
    title: 'OFCCP (Office of Federal Contract Compliance Programs)',
    copy: 'Use Workable to gather the required data and generate the necessary reports to stay compliant with OFCCP.'
  }
];

const ComplianceCertifications = () => (
  <Neutral900Section>
    <Container>
      <Grid fluid>
        <Row>
          <Col lg={12}>
            <LeftCenteredMargined>Compliance made simple</LeftCenteredMargined>
          </Col>
          {Certifications.map((item, index) => (
            <Col lg={6} key={index}>
              <DivMarginedBottomXl>
                <DivMarginedBottomSm>
                  <PictureWrapper
                    imgPath={imagePath}
                    imageUrl={item.imageUrl}
                    imageTypeFallback="png"
                    altImage={`${item.title}  icon`}
                    loading="lazy"
                  />
                </DivMarginedBottomSm>
                <H2Neutral50MarginSm className="heading-5">{item.title}</H2Neutral50MarginSm>
                <PNeutral50MarginSm>{item.copy}</PNeutral50MarginSm>
              </DivMarginedBottomXl>
            </Col>
          ))}
        </Row>
      </Grid>
    </Container>
  </Neutral900Section>
);

export default ComplianceCertifications;
